<dashboard-loader *ngIf="isLoadingModules$ | async" [title]="'Loading modules...'"></dashboard-loader>
<div *ngIf="modulesLoaded$ | async" class="tiim-material-theme dashboard-timing-rules-dialog">
  <div class="dashboard-timing-rules-dialog__title">
    <dashboard-dialog-title [title]="moduleName"></dashboard-dialog-title>
  </div>
  <mat-dialog-content class="dashboard-timing-rules-dialog__content" fxLayout="column" fxLayoutGap="20px">
    <mat-tab-group
      class="timing-rules"
      [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="timing-rules-tab-label">
            Timing Rules
          </span>
        </ng-template>
        <div class="dashboard-timing-rules-dialog__content-tab-body">
          <div
            *ngIf="!privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
            fxLayout="column"
            fxLayoutAlign=" center"
          >
            You are not allowed to add / edit this module timing.
          </div>
          <div *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)">
            <div *ngIf="!triggers?.length" fxLayout="column" fxLayoutAlign=" center" fxLayoutGap="20px">
              <div fxLayout="row">Modules will be available to the participants by default.</div>
              <div fxLayout="row">
                If you don't want this module to be visible by default, you can add one of multiple timing rules below.
              </div>
              <div fxLayout="row">
                <button mat-raised-button color="accent" (click)="enableTimingRules()">
                  {{ 'Enable Timing Rules' | uppercase }}
                </button>
              </div>
            </div>
            <div *ngIf="triggers?.length" fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="20px">
              <div class="timing-rule-card"
                   *ngFor="let trigger of triggers; let triggerIndex = index">
                <div class="timing-rule-card-header"
                     (click)="expandTrigger(trigger)">
                  <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                      <strong>Timing rule {{ triggerIndex + 1 }}</strong>
                    </div>
                    <div fxLayout="column">
                      <mat-icon *ngIf="getExpandTrigger(trigger)">
                        expand_less
                      </mat-icon>
                      <mat-icon *ngIf="!getExpandTrigger(trigger)">
                        expand_more
                      </mat-icon>
                    </div>
                  </div>
                </div>
                <mat-card class="mat-elevation-z0" fxLayout="row">
                  <mat-card-content *ngIf="getExpandTrigger(trigger)" fxFlex="100" fxLayoutGap="30px">
                    <a class="dashboard-timing-rules-dialog__content-remove" (click)="removeTrigger(triggerIndex)">
                      <mat-icon>close</mat-icon>
                    </a>
                    <div>
                    <span class="dashboard-timing-rules-dialog__content-error" *ngIf="errors && errors[triggerIndex]">
                      {{ errors[triggerIndex] }}
                    </span>
                    </div>
                    <div
                      class="dashboard-timing-rules-dialog__content-trigger"
                      fxLayout="row"
                      *ngFor="let rule of trigger.rules; let triggerRuleIndex = index">
                      <div fxLayout="column" fxFlex="100" fxLayoutGap="15px">
                        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="20px">
                          <div fxLayout="column" fxFlex="20">
                            <mat-form-field *ngIf="triggerRuleIndex === 0">
                              <mat-select [value]="0"
                                          [(ngModel)]="rule.disable"
                                          (selectionChange)="ruleTypeChange(trigger.rules, $event.value)">
                                <mat-option [value]="0">Open module</mat-option>
                                <mat-option [value]="1">Close module</mat-option>
                                <mat-option *ngIf="triggers.length < 2"
                                            [value]="2">ESM module</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <strong *ngIf="triggerRuleIndex > 0">
                              and
                            </strong>
                          </div>
                          <div
                            fxLayout="column"
                            fxFlex="70">
                            <mat-form-field *ngIf="rule.disable === 0">
                              <mat-select
                                [value]="''"
                                [(ngModel)]="rule.triggerType"
                                (ngModelChange)="initRelativeOffsets(rule)">
                                <mat-option [disabled] [value]="''">Select a type of open rule</mat-option>
                                <mat-option *ngFor="let rule of OPEN_TIMING_RULES" [value]="rule.type">
                                  {{ rule.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="rule.disable === 1">
                              <mat-select
                                [value]="''"
                                [(ngModel)]="rule.triggerType"
                                (ngModelChange)="initRelativeOffsets(rule)">
                                <mat-option [disabled] [value]="''">Select a type of closing rule</mat-option>
                                <mat-option *ngFor="let rule of CLOSING_TIMING_RULES" [value]="rule.type">
                                  {{ rule.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="rule.disable === 2">
                              <mat-select
                                [value]="''"
                                [(ngModel)]="rule.triggerType"
                                (ngModelChange)="initRelativeOffsets(rule)">
                                <mat-option [disabled] [value]="''">Select a type of ESM rule</mat-option>
                                <mat-option *ngFor="let rule of ESM_TIMING_RULES" [value]="rule.type">
                                  {{ rule.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="column" fxFlex="10">
                            <a
                              class="dashboard-timing-rules-dialog__content-trigger-remove"
                              *ngIf="trigger.rules.length > 1"
                              (click)="removeTriggerRule(trigger, triggerRuleIndex)">
                              <mat-icon>delete</mat-icon>
                            </a>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'relative_from_intervention'">
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayoutGap="10px">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center">
                              <div *ngFor="let unit of TIMER_ARRAY_UNITS" fxFlex="20">
                                <mat-form-field fxFill>
                                  <input matInput type="number" placeholder="{{ unit }}" [min]="0"
                                         [(ngModel)]="rule[unit]"/>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'relative_from_module'">
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayoutGap="10px">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center">
                              <div *ngFor="let unit of TIMER_ARRAY_UNITS" fxFlex="20">
                                <mat-form-field fxFill>
                                  <input matInput type="number" placeholder="{{ unit }}" [min]="0"
                                         [(ngModel)]="rule[unit]"/>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'relative_from_module'"
                        >
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayout="column" fxFlex="20">
                            <strong>After finishing</strong>
                          </div>
                          <div fxLayout="column" fxFlex="60">
                            <mat-form-field>
                              <mat-select [value]="0" [(ngModel)]="rule.moduleId">
                                <mat-option [disabled] [value]="0">
                                  {{
                                  availableModules?.length ? 'Select a module' : 'There are no modules in this intervention'
                                  }}
                                </mat-option>
                                <mat-option *ngFor="let module of availableModules" [value]="module.id">
                                  {{ module.name ? module.name : 'Module#' + module.id }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'unfinished_module'"
                        >
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayout="column" fxFlex="20">
                            <strong>Module</strong>
                          </div>
                          <div fxLayout="column" fxFlex="60">
                            <mat-form-field>
                              <mat-select [value]="0" [(ngModel)]="rule.moduleId">
                                <mat-option [disabled] [value]="0">
                                  {{
                                  availableModules?.length ? 'Select a module' : 'There are no modules in this intervention'
                                  }}
                                </mat-option>
                                <mat-option *ngFor="let module of availableModules" [value]="module.id">
                                  {{ module.name ? module.name : 'Module#' + module.id }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'based_on_answer'"
                        >
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayout="column" fxFlex="20">
                            <strong>Trigger when</strong>
                          </div>
                          <div fxLayout="column" fxFlex="30">
                            <mat-form-field>
                              <mat-select [value]="0" [(ngModel)]="rule.moduleId">
                                <mat-option [disabled] [value]="0">
                                  {{
                                  availableModules?.length ? 'Select a module' : 'There are no modules in this intervention'
                                  }}
                                </mat-option>
                                <mat-option *ngFor="let module of availableModules" [value]="module.id">
                                  {{ module.name ? module.name : 'Module#' + module.id }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="column" fxFlex="30" *ngIf="rule.moduleId">
                            <mat-form-field>
                              <mat-select [value]="0" [(ngModel)]="rule.moduleItemId"
                                          (ngModelChange)="initRuleOptions(rule)">
                                <mat-option [disabled] [value]="0"> Select a module item</mat-option>
                                <mat-option *ngFor="let moduleItem of moduleItems[rule.moduleId]"
                                            [value]="moduleItem.id">
                                  {{ moduleItem.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'based_on_answer' && rule.moduleItemId"
                        >
                          <div fxLayout="column" fxFlex="40"></div>
                          <div fxLayout="column" fxFlex="30">
                            <mat-form-field>
                              <mat-select [value]="'=='" [(ngModel)]="rule.operator">
                                <mat-option
                                  *ngFor="let operator of ruleOptions[rule.moduleItemId]?.operators"
                                  [value]="operator.operator"
                                >
                                  {{ operator.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="column" fxFlex="30">
                            <mat-form-field appearance="fill"
                                            *ngIf="ruleOptions[rule.moduleItemId]?.answerOptions?.length">
                              <mat-select [(ngModel)]="rule.answer">
                                <mat-option
                                  *ngFor="
                            let answerOption of ruleOptions[rule.moduleItemId]?.answerOptions;
                            let answerOptionIndex = index
                          "
                                  [value]="
                            ruleOptions[rule.moduleItemId].responseType === ModuleItemAvailableType.NUMBER
                              ? answerOption.toString()
                              : answerOptionIndex.toString()
                          "
                                >
                                  {{ answerOption }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill"
                                            *ngIf="!ruleOptions[rule.moduleItemId]?.answerOptions?.length">
                              <input matInput placeholder="Your answer here..." required [(ngModel)]="rule.answer"/>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'fixed_date'"
                        >
                          <div fxLayout="column" fxFlex="20"></div>
                          <mat-form-field>
                            <input
                              matInput
                              [ngxMatDatetimePicker]="triggerRulePicker"
                              placeholder="Fixed date and time"
                              [(ngModel)]="rule.fixedDate"
                              [min]="now"
                            />
                            <mat-datepicker-toggle
                              [disabled]="false"
                              matSuffix
                              [for]="triggerRulePicker"
                            ></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #triggerRulePicker [showSeconds]="false" [stepHour]="1"
                                                     [stepMinute]="1">
                            </ngx-mat-datetime-picker>
                          </mat-form-field>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayout="20px"
                          *ngIf="rule.triggerType === 'calculated_variable'"
                        >
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayout="column" fxFlex="20">
                            <strong>Trigger when</strong>
                          </div>
                          <div fxLayout="column" fxFlex="60">
                            <mat-form-field>
                              <mat-select
                                [value]="0"
                                [(ngModel)]="rule.calculatedVariableId"
                                (ngModelChange)="initCalculatedVariableOptions(rule)"
                              >
                                <mat-option [disabled] [value]="0">
                                  {{
                                  calculatedVariables?.length
                                    ? 'Select a calculated variable'
                                    : 'There are no calculated variables'
                                  }}
                                </mat-option>
                                <mat-option
                                  *ngFor="let calculatedVariable of calculatedVariables"
                                  [value]="calculatedVariable.id"
                                >
                                  {{ calculatedVariable.uniqueName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'calculated_variable' && rule.calculatedVariableId"
                        >
                          <div fxLayout="column" fxFlex="40"></div>
                          <div fxLayout="column" fxFlex="30">
                            <mat-form-field>
                              <mat-select [value]="0" [(ngModel)]="rule.operator">
                                <mat-option *ngFor="let operator of calculatedVariablesOperators"
                                            [value]="operator.operator">
                                  {{ operator.label }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="column" fxFlex="30">
                            <mat-form-field appearance="fill">
                              <input matInput placeholder="Enter value here..." required [(ngModel)]="rule.answer"/>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'relative_after_module'">
                          <div fxLayout="column" fxFlex="20"></div>
                          <div fxLayoutGap="10px">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center">
                              <div *ngFor="let unit of TIMER_ARRAY_UNITS" fxFlex="20">
                                <mat-form-field fxFill>
                                  <input matInput type="number" placeholder="{{ unit }}" [min]="0"
                                         [(ngModel)]="rule[unit]"/>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign="start stretch"
                          *ngIf="rule.triggerType === 'esm_fixed_date'">
                          <div fxFlex="100">
                            <dashboard-esm-calender [moduleTitle]="moduleName"
                                                    [contentItem]="contentItem"
                                                    [triggerType]="'esm_fixed_date'"
                                                    [esmTriggerRules]="this.esmFixedRules">
                            </dashboard-esm-calender>
                          </div>
                        </div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign=" center"
                          fxLayoutGap="20px"
                          *ngIf="rule.triggerType === 'esm_relative_date'">
                          <div fxFlex="100">
                            <dashboard-esm-calender [moduleTitle]="moduleName"
                                                    [contentItem]="contentItem"
                                                    [triggerType]="'esm_relative_date'"
                                                    [esmTriggerRules]="this.esmRelativeRules">
                            </dashboard-esm-calender>
                          </div>
                        </div>
                        <div *ngIf="rule.disable !== 2" fxLayout="row" class="dashboard-timing-rules-dialog__content-trigger-divider">
                          <mat-divider></mat-divider>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="triggers[0].rules[0]?.disable !== 2" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
                      <button mat-button color="primary"
                              (click)="addTriggerRule(trigger)"
                              [matTooltip]="triggerRuleIndex === 0
                              ? 'This adds a new condition to the timing rule. All conditions have to be true to open module'
                              : 'This adds a new condition to the timing rule. All conditions have to be true to close module'"
                              matTooltipPosition="above">
                        {{ 'Add condition' | uppercase }}
                      </button>
                    </div>
                  </mat-card-content>
                </mat-card>
                <div class="timing-rule-or-operator"
                     *ngIf="triggers?.length > 1 && triggerIndex + 1 != triggers?.length">
                  OR
                </div>
              </div>
              <div *ngIf="triggers[0].rules[0]?.disable !== 2" fxLayout="row" fxLayoutAlign="center">
                <button mat-button color="primary"
                        (click)="addTrigger()"
                        [matTooltip]="'This adds a new rule. Only one rule needs to be true'"
                        matTooltipPosition="above">
                  {{ 'Add timing rule' | uppercase }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span class="timing-rules-tab-label">
            Notifications
          </span>
        </ng-template>
        <div class="dashboard-timing-rules-dialog__content-tab-body">
          <dashboard-notification>
          </dashboard-notification>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div fxLayout="row" fxLayoutAlign="end">
      <button mat-raised-button
              color="accent"
              (click)="saveTimingRules()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </mat-dialog-content>
</div>
